import { useAppState } from '../../../AppStateProvider';
import type { Contact } from '../../../domain/contact';
import { createContact, mergeContact } from '../../../domain/contact';
import { appStore } from '../../../services/appStore';

import { useLinkedinContactQuery } from './useLinkedinContactQuery';

export const useLinkedinContact = () => {
  const contactQuery = useLinkedinContactQuery();
  const { collectedContactInfo } = useAppState();

  const isLoading = !collectedContactInfo || contactQuery?.isPending;

  let contact = mergeContact(contactQuery?.data, collectedContactInfo);

  if (contactQuery.isError || !contact) {
    contact = createContact(collectedContactInfo) as Contact;
    const companyLinkedinIds = collectedContactInfo?.numericCompanyLinkedinIds;
    if (companyLinkedinIds?.[0]) {
      appStore.setCompanyLinkedinId(companyLinkedinIds?.[0].toString());
    }
  }

  return {
    isLoading,
    contact,
  };
};
